import { ColDef } from 'ag-grid-community';
import { ServiceRole } from 'pco-product-service-internal-consumer';
import { isEbankingServiceRoleProperties } from '../../../productSpecificProperties';
import {
  formatEbankingBlocked,
  formatEbankingJNumber,
  formatEbankingLastLogin,
} from '../../../ebankingAttributeFormat';

export const ebankingServiceRoleColumns: ColDef<ServiceRole>[] = [
  {
    headerName: 'J-number',
    valueGetter: ({ data }) => {
      const properties = data?.productSpecificProperties;
      return formatEbankingJNumber(isEbankingServiceRoleProperties(properties) ? properties.jNumber : undefined);
    },
    sortable: true,
    resizable: true,
    filter: false,
    flex: 1,
    minWidth: 110,
  },
  {
    headerName: 'Blocked',
    valueGetter: ({ data }) => {
      const properties = data?.productSpecificProperties;
      return formatEbankingBlocked(isEbankingServiceRoleProperties(properties) ? properties.isBlocked : undefined);
    },
    sortable: true,
    resizable: true,
    filter: false,
    flex: 1,
    minWidth: 90,
  },
  {
    headerName: 'Last login',
    valueGetter: ({ data }) => {
      const properties = data?.productSpecificProperties;
      return formatEbankingLastLogin(isEbankingServiceRoleProperties(properties) ? properties.lastLogin : undefined);
    },
    sortable: true,
    resizable: true,
    filter: false,
    flex: 1,
    minWidth: 110,
  },
];
